import React, { Component } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

class VideoInner extends Component {
  playerId = `video-player-${(new Date()) * 1}`;

  source = this.props.src;

  constructor(props) {
    super(props);

    this.state = {
      isReady: false,
    };

    this.options = {
      aspectRatio: '16:9',
      controlBar: {
        timeDivider: false,
        durationDisplay: false,
        currentTimeDisplay: false,
        remainingTimeDisplay: false,
        liveDisplay: false,
        seekToLive: false,
        customControlSpacer: false,
        playbackRateMenuButton: false,
        chaptersButton: false,
        descriptionsButton: false,
        subtitlesButton: false,
        captionsButton: false,
        audioTrackButton: false,
        volumePanel: {
          inline: false,
          vertical: true,
        },
      },
    };
  }

  async componentDidMount() {
    window.HELP_IMPROVE_VIDEOJS = false;
    const { audioOnly } = this.props;

    const options = {
      ...this.options,
      ...this.props,
      src: this.source,
    };

    if (audioOnly) {
      options.poster = null;
    }

    const hasYouTubeSource = this.props.sources?.some((sourceItem) => sourceItem.type === 'video/youtube');

    if (hasYouTubeSource) {
      await import('videojs-youtube');
    }

    this.setState({
      isReady: true,
    });
  }

  componentDidUpdate() {
    const options = {
      ...this.options,
      ...this.props,
      src: this.source,
    };

    if (this.state.isReady) {
      this.player = videojs(this.playerId, options, () => {});
    }
  }

  componentWillUnmount() {
    if (this.player) {
      // Destroy player.
      this.player.dispose();
    }
  }

  render() {
    if (!this.state.isReady) {
      return null;
    }

    const { playsInline, poster } = this.props;

    return (
      <div className="Video">
        <div data-vjs-player>
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            ref={(node) => this.playerId = node}
            className="video-js video-player vjs-show-big-play-button-on-pause vjs-show-big-play-button-on-controls"
            playsInline={playsInline}
            poster={poster}
          />
        </div>
      </div>
    );
  }
}

VideoInner.defaultProps = {
  autoplay: false,
  controls: true,
  loop: false,
  muted: false,
  poster: null,
  preload: 'auto',
  src: null,
  sources: null,
  height: '',
  width: '',
  aspectRatio: '16:9',
  audioOnly: false,
};

export default VideoInner;
